import { usePublicShowcaseNavPageBoards } from '~/components/v2/components/showcase/hooks/usePublicShowcaseNavPageBoards';
import { type PublicShowcaseContextValue } from '~/providers/PublicShowcaseProvider';
import { usePublicShowcaseBoardGalleryViewItems } from '~/swr-hooks/gallery/galleryView/usePublicShowcaseBoardGalleryViewItems';
import { usePublicShowcaseGalleryViewItems } from '~/swr-hooks/gallery/galleryView/usePublicShowcaseGalleryViewItems';
import { usePublicShowcaseBoardTableViewItems } from '~/swr-hooks/gallery/tableView/usePublicShowcaseBoardTableViewItems';

/**
 * Live `/a` implementations of the layout's page-listing and board-drill members. ShortUrl only —
 * passcode/expiry/disabled stay enforced for visitors.
 */
export const PUBLIC_SHOWCASE_LAYOUT_DATA: Pick<
  PublicShowcaseContextValue,
  'useBoardGalleryViewItems' | 'useBoardTableViewItems' | 'useGalleryViewItems' | 'useNavPageBoards'
> = {
  useBoardGalleryViewItems: usePublicShowcaseBoardGalleryViewItems,
  useBoardTableViewItems: usePublicShowcaseBoardTableViewItems,
  useGalleryViewItems: usePublicShowcaseGalleryViewItems,
  useNavPageBoards: usePublicShowcaseNavPageBoards,
};
